// OBT F3-D — İnceleme detayına gömülü, SALT-OKUNUR park varlık geçmişi özeti (§5).
// Formen "Havuz çalışmıyor" der; BM/Müdür burada varlığın son değişim/firma/garanti/
// ihale bağlamını görür. Kapsam backend'de; erişim yoksa sessizce gizlenir.
import { Card, CardContent } from '@/components/ui/card';
import { Archive } from 'lucide-react';
import { ObtLoading } from '../ObtStates';
import { useParkAssetHistory } from './hooks/useParkAssetHistory';
import { AssetTypeBadge, WarrantyBadge } from './MemoryBadges';
import { ASSET_TYPE_LABELS, ASSET_EVENT_LABELS, memoryLabel } from './memoryEnums';
import { formatDate } from '../report/reportFormat';

export default function ParkAssetHistoryCard({ parkId, enabled = true }) {
  const { loading, error, history } = useParkAssetHistory(parkId, {
    enabled: enabled && Boolean(parkId),
  });

  if (!parkId) return null;
  // Erişim yoksa (404/403) kart hiç gösterilmez — inceleme akışını bozmaz.
  if (error) return null;

  const assets = history?.assets || [];

  return (
    <Card>
      <CardContent className="space-y-2 p-4">
        <div className="flex items-center gap-2">
          <Archive className="h-4 w-4 text-gray-500" aria-hidden="true" />
          <h3 className="text-sm font-semibold text-gray-900">Varlık Geçmişi (Kurumsal Hafıza)</h3>
        </div>
        {loading && <ObtLoading label="Varlık geçmişi yükleniyor…" />}
        {!loading && assets.length === 0 && (
          <p className="text-sm text-gray-500">Bu park için kayıtlı varlık geçmişi yok.</p>
        )}
        {!loading &&
          assets.map(({ asset, records }) => {
            const latest = (records || [])[0] || null;
            return (
              <div key={String(asset.asset_id)} className="rounded-md border border-gray-100 p-2">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-sm font-medium text-gray-900">
                    {asset.name || memoryLabel(ASSET_TYPE_LABELS, asset.asset_type)}
                  </span>
                  <AssetTypeBadge type={asset.asset_type} />
                  <WarrantyBadge status={asset.warranty_status} />
                </div>
                {latest ? (
                  <div className="mt-1 flex flex-wrap gap-x-4 gap-y-0.5 text-xs text-gray-600">
                    <span>
                      Son {memoryLabel(ASSET_EVENT_LABELS, latest.event_type)}: {formatDate(latest.event_date)}
                    </span>
                    {latest.company_name && <span>Firma: {latest.company_name}</span>}
                    {latest.tender_number && <span>İhale: {latest.tender_number}</span>}
                    {latest.warranty_end_date && <span>Garanti bitişi: {formatDate(latest.warranty_end_date)}</span>}
                  </div>
                ) : (
                  <p className="mt-1 text-xs text-gray-400">Henüz geçmiş kaydı yok.</p>
                )}
              </div>
            );
          })}
      </CardContent>
    </Card>
  );
}
